export const NATIVE_LOGOUT_PENDING_KEY = 'pb.nativeLogoutPending';

/** Remove MSAL's redirect lock after a native browser flow has returned. */
export function clearMsalInteractionState(): void {
  for (const storage of [sessionStorage, localStorage]) {
    try {
      const keys: string[] = [];
      for (let i = 0; i < storage.length; i++) {
        const key = storage.key(i);
        if (key?.includes('interaction.status')) keys.push(key);
      }
      keys.forEach((key) => storage.removeItem(key));
    } catch {
      // Storage may be unavailable in privacy-restricted browser contexts.
    }
  }
}
